import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipRule="evenodd"
      viewBox="0 0 512 512"
      width="17"
      height="17"
    >
      <g transform="translate(-21168.3 -16442.1)">
        <g transform="matrix(.26667 0 0 .47407 21168.3 16442.1)">
          <path fill="none" d="M0 0H1920V1080H0z"></path>
          <path
            fill="#fff"
            d="M17721.1 7385.28l-42.6 59.38c-6.7 9.43-19.7 13.97-36.6 12.58-21.8-1.8-50.7-13.32-78.4-33.19-27.7-19.88-47.9-43.56-56.7-63.61-6.7-15.54-6.6-29.26.2-38.7l42.5-59.38c6.8-9.43 19.8-13.97 36.6-12.58 21.8 1.8 50.8 13.33 78.5 33.2 27.7 19.87 47.9 43.55 56.6 63.6 6.8 15.54 6.6 29.27-.1 38.7zm-160.2-114.76c4.4-6.1 13.2-7.68 24.1-6.78 19.9 1.64 46.1 12.48 71.4 30.62 25.3 18.13 44 39.5 52 57.8 4.3 10.03 5.7 18.87 1.3 24.97l5.7 4.07-5.7-4.07-42.6 59.38c-4.3 6.09-13.1 7.68-24 6.77-19.9-1.63-46.2-12.48-71.5-30.61-25.3-18.14-44-39.51-51.9-57.8-4.4-10.04-5.7-18.88-1.3-24.97l42.5-59.38z"
            transform="matrix(5.26799 0 0 3.76676 -5053.35 -2457.11) matrix(1.53485 0 0 1.20744 -25893.4 -8083.24)"
          ></path>
          <path
            fill="#fff"
            d="M17550.4 7275.75c13.9-19.4 61-9.44 105.2 22.22 44.2 31.67 68.8 73.14 54.9 92.54l-42.5 59.38c-13.9 19.4-61.1 9.44-105.3-22.23-44.2-31.67-68.8-73.13-54.9-92.53l42.6-59.38z"
            transform="matrix(5.26799 0 0 3.76676 -5053.35 -2457.11) matrix(1.53485 0 0 1.20744 -25885.9 -8092.74)"
          ></path>
          <g transform="matrix(5.26799 0 0 3.76676 -5053.35 -2457.11) matrix(1.58178 0 0 1.24436 -28438.7 -19162.2)">
            <path
              fill="#0E0F23"
              d="M18640.6 15952.1c6-8.4 17.6-12.1 32.6-10.9 20.7 1.7 48.1 12.8 74.5 31.6 26.3 18.9 45.6 41.4 53.8 60.4 6 13.8 6.2 26 .2 34.4l-41.2 57.6c-6 8.4-17.7 12.1-32.6 10.9-20.7-1.8-48.2-12.8-74.5-31.7-26.4-18.8-45.6-41.3-53.9-60.3-6-13.8-6.2-26-.2-34.4l41.3-57.6zm155.4 111.4v-.1c4.8-6.6 3.8-16.4-.9-27.4-7.9-18.1-26.4-39.4-51.6-57.4-25.1-18-51.2-28.7-70.9-30.3-12-1-21.5 1.2-26.3 7.9l-.2.4c-4.5 6.7-3.5 16.2 1.2 27 7.9 18.2 26.4 39.5 51.5 57.5s51.2 28.7 70.9 30.3c11.8.9 21.1-1.2 26-7.5l.3-.5v.1zm-64.2-68.6c12.6 9 21.9 19.7 25.8 28.8 2.3 5.1 2.9 9.6.6 12.7-2.2 3.1-6.7 4-12.2 3.5-9.9-.8-22.9-6.2-35.5-15.2-12.6-9-21.9-19.6-25.8-28.7-2.2-5.1-2.8-9.6-.6-12.7 2.2-3.1 6.7-4 12.3-3.6 9.8.9 22.9 6.2 35.4 15.2z"
            ></path>
            <clipPath id="_clip1">
              <path d="M18640.6 15952.1c6-8.4 17.6-12.1 32.6-10.9 20.7 1.7 48.1 12.8 74.5 31.6 26.3 18.9 45.6 41.4 53.8 60.4 6 13.8 6.2 26 .2 34.4l-41.2 57.6c-6 8.4-17.7 12.1-32.6 10.9-20.7-1.8-48.2-12.8-74.5-31.7-26.4-18.8-45.6-41.3-53.9-60.3-6-13.8-6.2-26-.2-34.4l41.3-57.6zm155.4 111.4v-.1c4.8-6.6 3.8-16.4-.9-27.4-7.9-18.1-26.4-39.4-51.6-57.4-25.1-18-51.2-28.7-70.9-30.3-12-1-21.5 1.2-26.3 7.9l-.2.4c-4.5 6.7-3.5 16.2 1.2 27 7.9 18.2 26.4 39.5 51.5 57.5s51.2 28.7 70.9 30.3c11.8.9 21.1-1.2 26-7.5l.3-.5v.1zm-64.2-68.6c12.6 9 21.9 19.7 25.8 28.8 2.3 5.1 2.9 9.6.6 12.7-2.2 3.1-6.7 4-12.2 3.5-9.9-.8-22.9-6.2-35.5-15.2-12.6-9-21.9-19.6-25.8-28.7-2.2-5.1-2.8-9.6-.6-12.7 2.2-3.1 6.7-4 12.3-3.6 9.8.9 22.9 6.2 35.4 15.2z"></path>
            </clipPath>
            <g clipPath="url(#_clip1)">
              <path
                fill="url(#_Linear2)"
                d="M17004.5 15714.1c1.1 0 2.9-1.1 3.9-1.4 3.5-1.1 7-2.2 10.6-3.1 10.5-2.7 21.4-4.2 32.2-3.2 17 1.6 32.4 14.1 49.5 12.4 9.6-.9 16.4-6.6 24.8-10.5 8-3.9 16.8-5.6 25.7-4.8 26.5 2.2 36.5 24.2 63.4 23 22.3-1 13.6-12.3 35-16.3.2-.1 51.7 19 52.1 22.3 1.5 12.7-27.1 162.3-25.8 162.3l-255.1-39.5-16.3-141.2z"
                transform="matrix(1 0 0 -2.3719 1581.65 53337.7)"
              ></path>
            </g>
          </g>
          <path
            fill="none"
            stroke="#fff"
            strokeDasharray="6,6,75,75"
            strokeDashoffset="3"
            strokeWidth="3"
            d="M18607.7 16015.7c1.1 26.3 27 51.4 46.9 68.4 27.7 23.6 72.3 41.3 97.2 37.3"
            transform="matrix(5.26799 0 0 3.76676 -5053.35 -2457.11) matrix(1.58178 0 0 1.24436 -28393.2 -19215.7)"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="_Linear2"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(27.908 -59.2347 -140.499 -11.7661 17095.7 15766.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#27B0E6"></stop>
          <stop offset="0.52" stopColor="#C26BB3"></stop>
          <stop offset="1" stopColor="#FA52A0"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon
